import { EditInvoiceAddressDto } from "../../../../../models/app/admin/invoiceAddress";
import { AddInvoiceAddressFormValidationSchema } from "../AddInvoiceAddressForm/AddInvoiceAddressFormValues";

export type EditInvoiceAddressFormValues = EditInvoiceAddressDto;

export const EditInvoiceAddressFormValidationSchema =
    AddInvoiceAddressFormValidationSchema;
